import { Directive } from '@angular/core';

@Directive({
  selector: '[appPageFooter]',
})
export class PageFooterDirective {
  constructor() {}
}
